import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../constants";
import "./CareTeamCard.scss";
import { rolePermissionsService } from "../../../services/rolePermissions.service";
import _ from "lodash";
import {
  IonCol,
  IonIcon,
  IonModal,
  IonRow,
} from "@ionic/react";
import { close } from "ionicons/icons";
import { CaseHistoryService } from "../../../pages/CaseHistory/CaseHistory.service";
import DoctorCard from "../DoctorList/Components/DoctorCard/doctor-card";
import { doctorListInputData } from "../DoctorList/doctor-list.model";
import Loader from "../Loader/Loader";

interface CareTeamProps {
  careTeamData: any;
  patientID?: any;
}

const CareTeamCard: React.FC<CareTeamProps> = (props) => {
  const iconList: any = CONSTANTS.CARE_TEAM_CATEGORY;
  const [enableCareTeamMembersModal, setCareTeamMembersModal] = useState(false);
  const [careTeamMembers, setCareTeamMembers] = useState([]);
  const [doctorListInput, setDoctorListInput]: any = useState({});
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [isLoaderActive, setLoaderStatus] = useState(true);
  const [careTeamName, getCareTeamName] = useState();

  useEffect(() => {
    setDoctorListInputData();
  }, []);

  const setDoctorListInputData = () => {
    const doctorListInput: doctorListInputData = {
      componentName: CONSTANTS.COMPONENTS.STATUS_BOARD,
      isMultiSelectEnabled: false,
      isShowColorBadge: false,
      isHideProfilePic: false,
    };
    setDoctorListInput(doctorListInput);
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  };

  async function getCareTeamMembers(careTeamID: any) {
    setLoaderStatus(true);
    let params = {
      care_team_id: careTeamID,
      patientId: props.patientID,
    };
    const getCareTeamMembersResult: any =
      await CaseHistoryService.getCareTeamMembers(params);
    if (getCareTeamMembersResult.isSuccess) {
      setLoaderStatus(false);
      setCareTeamMembers(getCareTeamMembersResult.groupList);
    } else {
      setLoaderStatus(false);
    }
  }

  return (
    <div>
      <IonModal
        isOpen={enableCareTeamMembersModal}
        backdropDismiss={false}
        className="care-teams-list-modal"
      >
        <div className="care-team-list-modal-container">
          <span className="care-team-header">{careTeamName}</span>
          <div
            className="close-care-team-modal-icon"
            onClick={() => {
              setCareTeamMembersModal(false);
            }}
          >
            <IonIcon icon={close} />
          </div>
          <div className="care-team-member-list-container">
            {isLoaderActive && (
              <div className="loader-container">
                <Loader></Loader>
              </div>
            )}
            <IonRow>
              {!_.isEmpty(careTeamMembers)
                ? careTeamMembers.map((item: any, index: any) => {
                    return (
                      <IonCol size-lg="12" size="12" key={item.guid}>
                        <DoctorCard
                          key={item.guid}
                          numberBadge={item.numberBadge}
                          doctorData={item}
                          getSelectedCards={() => {}}
                          doctorListInputDetails={doctorListInput}
                          rolePermissions={rolePermissions}
                          isFromCaseHistoryDetails={false}
                          isFromCareTeamCard={true}
                        ></DoctorCard>
                      </IonCol>
                    );
                  })
                : [
                    !isLoaderActive && (
                      <div className="no-message-label" key={""}>
                        No providers are assigned.
                      </div>
                    ),
                  ]}
            </IonRow>
          </div>
        </div>
      </IonModal>
      <div className="care-team-container care-team-container-section">
        <div className="care-team-card-container">
          <div
            className={`icon-div-care-team ${
              iconList.CATEGORY[props.careTeamData?.category]
            }`}
          ></div>

          <div className="item-name">{props.careTeamData.name}</div>
          <div
            className="view-users-care-team icon-view"
            onClick={() => {
              setCareTeamMembersModal(true);
              getCareTeamMembers(props.careTeamData.id);
              getCareTeamName(props.careTeamData.name);
            }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default CareTeamCard;
